export enum FlightsListDrawerComponent {
  STOPS = "STOPS",
  AIRLINES = "AIRLINES",
  ALL_FILTERS = "ALL_FILTERS",
  SORT = "SORT",
  SEARCH = "SEARCH",
}
